import React, { Component } from "react";
import { InputNumber, message } from "antd";
import TableC from "../../basicElement/TableC";
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";
import ExportUtil from "../../../common/ExportUtil";
import UpdateLog from "./UpdateLog";


class StartService extends Component {
    state = {
        data: [],
        loading: false,
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryServerUnitByType,
            data: { serverType: 'START' },
            dataType: "json",
            doneResult: (res) => {
                this.setState({
                    data: res.data,
                });
            },
        };
        $.sendRequest(options);
    };

    update = (record, index) => {
        const { data } = this.state;
        const { isEdit = false } = record;
        if (isEdit){
            this.save(record, index);
        }else {
            data[index].isEdit = true;
            this.setState({
                data: [...data],
            })
        }
    };

    save = (record, index) => {
        const { serverPrice } = record;
        if (!serverPrice  && serverPrice != 0) {
            return message.warning('请输入基础单价')
        }
        const options = {
            method: "POST",
            url: API_URL.evaluate.modifyServerUnit,
            data: {
                ...record,
            },
            dataType: "json",
            doneResult: (res) => {
                const { data } = this.state;
                data[index].isEdit = false;
                this.setState({
                    data: [...data],
                },() => {
                    message.success(res.success);
                    this.loadData();
                })
            },
        };
        $.sendRequest(options);
    }

    handleChange = (value, index, key) => {
        const { data } = this.state;
        data[index][key] = value;
        this.setState({
            data: [...data],
        })
    };

    getColumns = () => [
        {
            title: "序号",
            key: "num",
            dataIndex: "num",
            width: 100,
        },
        {
            title: "启动服务内容",
            key: "serverContent",
            dataIndex: "serverContent",
            width: 220,
        },
        {
            title: "启动服务单价（元/中心）",
            key: "serverPrice",
            dataIndex: "serverPrice",
            width: 220,
            render: (text, record, index) => {
                const { isEdit = false } = record;
                return isEdit ?
                        <InputNumber
                            min={0}
                            precision={2}
                            step={0.01}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            placeholder='请输入'
                            style={{ width: 200 }}
                            value={text}
                            onChange={value => this.handleChange(value, index, 'serverPrice')}
                        />
                        : text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : (text === 0 ? '0' : '')
            }
        },
        {
            title: "操作",
            key: "operate",
            dataIndex: "operate",
            width: 100,
            render: (text, record, index) => {
                const { isEdit = false } = record;
                return (
                    // <span>
                    //     <a onClick={() => this.update(record, index)}>{isEdit ? '保存' : '修改'}</a>
                    //     <span className="ant-divider" />
                    //     <a onClick={() => this.UpdateLogRef.show(record)}>更新日志</a>
                    // </span>
                    '-'
                );
            }
        },
    ];

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = [];
        data.map((el, index) => {
            dataSource.push({
                ...el,
                num: index + 1,
            })
        })
        return dataSource;
    };

    render() {
        const { loading } = this.state;
        return (
                <div>
                    <TableC
                        rowKey={'serviceUnitPriceId'}
                        loading={loading}
                        scrollY={500}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                    />
                    <UpdateLog ref={el => this.UpdateLogRef = el}/>
                </div>
        );
    }
}

export default StartService;



// WEBPACK FOOTER //
// ./src/components/businessOffer/taskUnitPrice/StartService.js